"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NVDDetectionMetricsCvssMetricV31CvssDataToJSON = exports.NVDDetectionMetricsCvssMetricV31CvssDataFromJSONTyped = exports.NVDDetectionMetricsCvssMetricV31CvssDataFromJSON = exports.instanceOfNVDDetectionMetricsCvssMetricV31CvssData = exports.NVDDetectionMetricsCvssMetricV31CvssDataVersionEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataEnvironmentalSeverityEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedAvailabilityImpactEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedIntegrityImpactEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedConfidentialityImpactEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedScopeEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedUserInteractionEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedPrivilegesRequiredEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedAttackComplexityEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedAttackVectorEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataAvailabilityRequirementEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataIntegrityRequirementEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataConfidentialityRequirementEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataTemporalSeverityEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataReportConfidenceEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataRemediationLevelEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataExploitCodeMaturityEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataBaseSeverityEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataAvailabilityImpactEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataIntegrityImpactEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataConfidentialityImpactEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataScopeEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataUserInteractionEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataPrivilegesRequiredEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataAttackComplexityEnum = exports.NVDDetectionMetricsCvssMetricV31CvssDataAttackVectorEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataAttackVectorEnum = {
    Network: 'NETWORK',
    AdjacentNetwork: 'ADJACENT_NETWORK',
    Local: 'LOCAL',
    Physical: 'PHYSICAL'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataAttackComplexityEnum = {
    High: 'HIGH',
    Low: 'LOW'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataPrivilegesRequiredEnum = {
    High: 'HIGH',
    Low: 'LOW',
    None: 'NONE'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataUserInteractionEnum = {
    None: 'NONE',
    Required: 'REQUIRED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataScopeEnum = {
    Changed: 'CHANGED',
    Unchanged: 'UNCHANGED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataConfidentialityImpactEnum = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataIntegrityImpactEnum = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataAvailabilityImpactEnum = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataBaseSeverityEnum = {
    None: 'NONE',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataExploitCodeMaturityEnum = {
    Unproven: 'UNPROVEN',
    ProofOfConcept: 'PROOF_OF_CONCEPT',
    Functional: 'FUNCTIONAL',
    High: 'HIGH',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataRemediationLevelEnum = {
    OfficialFix: 'OFFICIAL_FIX',
    TemporaryFix: 'TEMPORARY_FIX',
    Workaround: 'WORKAROUND',
    Unavailable: 'UNAVAILABLE',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataReportConfidenceEnum = {
    Unknown: 'UNKNOWN',
    Reasonable: 'REASONABLE',
    Confirmed: 'CONFIRMED',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataTemporalSeverityEnum = {
    None: 'NONE',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataConfidentialityRequirementEnum = {
    High: 'HIGH',
    Low: 'LOW',
    None: 'NONE'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataIntegrityRequirementEnum = {
    High: 'HIGH',
    Low: 'LOW',
    None: 'NONE'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataAvailabilityRequirementEnum = {
    High: 'HIGH',
    Low: 'LOW',
    None: 'NONE'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedAttackVectorEnum = {
    Network: 'NETWORK',
    AdjacentNetwork: 'ADJACENT_NETWORK',
    Local: 'LOCAL',
    Physical: 'PHYSICAL',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedAttackComplexityEnum = {
    High: 'HIGH',
    Low: 'LOW',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedPrivilegesRequiredEnum = {
    High: 'HIGH',
    Low: 'LOW',
    None: 'NONE'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedUserInteractionEnum = {
    None: 'NONE',
    Required: 'REQUIRED',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedScopeEnum = {
    Changed: 'CHANGED',
    Unchanged: 'UNCHANGED',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedConfidentialityImpactEnum = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedIntegrityImpactEnum = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataModifiedAvailabilityImpactEnum = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH',
    NotDefined: 'NOT_DEFINED'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataEnvironmentalSeverityEnum = {
    None: 'NONE',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
};
/**
 * @export
 */
exports.NVDDetectionMetricsCvssMetricV31CvssDataVersionEnum = {
    _31: '3.1'
};
/**
 * Check if a given object implements the NVDDetectionMetricsCvssMetricV31CvssData interface.
 */
function instanceOfNVDDetectionMetricsCvssMetricV31CvssData(value) {
    var isInstance = true;
    isInstance = isInstance && "baseScore" in value;
    isInstance = isInstance && "baseSeverity" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "vectorString" in value;
    return isInstance;
}
exports.instanceOfNVDDetectionMetricsCvssMetricV31CvssData = instanceOfNVDDetectionMetricsCvssMetricV31CvssData;
function NVDDetectionMetricsCvssMetricV31CvssDataFromJSON(json) {
    return NVDDetectionMetricsCvssMetricV31CvssDataFromJSONTyped(json, false);
}
exports.NVDDetectionMetricsCvssMetricV31CvssDataFromJSON = NVDDetectionMetricsCvssMetricV31CvssDataFromJSON;
function NVDDetectionMetricsCvssMetricV31CvssDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attackVector': !(0, runtime_1.exists)(json, 'attackVector') ? undefined : json['attackVector'],
        'attackComplexity': !(0, runtime_1.exists)(json, 'attackComplexity') ? undefined : json['attackComplexity'],
        'privilegesRequired': !(0, runtime_1.exists)(json, 'privilegesRequired') ? undefined : json['privilegesRequired'],
        'userInteraction': !(0, runtime_1.exists)(json, 'userInteraction') ? undefined : json['userInteraction'],
        'scope': !(0, runtime_1.exists)(json, 'scope') ? undefined : json['scope'],
        'confidentialityImpact': !(0, runtime_1.exists)(json, 'confidentialityImpact') ? undefined : json['confidentialityImpact'],
        'integrityImpact': !(0, runtime_1.exists)(json, 'integrityImpact') ? undefined : json['integrityImpact'],
        'availabilityImpact': !(0, runtime_1.exists)(json, 'availabilityImpact') ? undefined : json['availabilityImpact'],
        'baseScore': json['baseScore'],
        'baseSeverity': json['baseSeverity'],
        'exploitCodeMaturity': !(0, runtime_1.exists)(json, 'exploitCodeMaturity') ? undefined : json['exploitCodeMaturity'],
        'remediationLevel': !(0, runtime_1.exists)(json, 'remediationLevel') ? undefined : json['remediationLevel'],
        'reportConfidence': !(0, runtime_1.exists)(json, 'reportConfidence') ? undefined : json['reportConfidence'],
        'temporalScore': !(0, runtime_1.exists)(json, 'temporalScore') ? undefined : json['temporalScore'],
        'temporalSeverity': !(0, runtime_1.exists)(json, 'temporalSeverity') ? undefined : json['temporalSeverity'],
        'confidentialityRequirement': !(0, runtime_1.exists)(json, 'confidentialityRequirement') ? undefined : json['confidentialityRequirement'],
        'integrityRequirement': !(0, runtime_1.exists)(json, 'integrityRequirement') ? undefined : json['integrityRequirement'],
        'availabilityRequirement': !(0, runtime_1.exists)(json, 'availabilityRequirement') ? undefined : json['availabilityRequirement'],
        'modifiedAttackVector': !(0, runtime_1.exists)(json, 'modifiedAttackVector') ? undefined : json['modifiedAttackVector'],
        'modifiedAttackComplexity': !(0, runtime_1.exists)(json, 'modifiedAttackComplexity') ? undefined : json['modifiedAttackComplexity'],
        'modifiedPrivilegesRequired': !(0, runtime_1.exists)(json, 'modifiedPrivilegesRequired') ? undefined : json['modifiedPrivilegesRequired'],
        'modifiedUserInteraction': !(0, runtime_1.exists)(json, 'modifiedUserInteraction') ? undefined : json['modifiedUserInteraction'],
        'modifiedScope': !(0, runtime_1.exists)(json, 'modifiedScope') ? undefined : json['modifiedScope'],
        'modifiedConfidentialityImpact': !(0, runtime_1.exists)(json, 'modifiedConfidentialityImpact') ? undefined : json['modifiedConfidentialityImpact'],
        'modifiedIntegrityImpact': !(0, runtime_1.exists)(json, 'modifiedIntegrityImpact') ? undefined : json['modifiedIntegrityImpact'],
        'modifiedAvailabilityImpact': !(0, runtime_1.exists)(json, 'modifiedAvailabilityImpact') ? undefined : json['modifiedAvailabilityImpact'],
        'environmentalScore': !(0, runtime_1.exists)(json, 'environmentalScore') ? undefined : json['environmentalScore'],
        'environmentalSeverity': !(0, runtime_1.exists)(json, 'environmentalSeverity') ? undefined : json['environmentalSeverity'],
        'version': json['version'],
        'vectorString': json['vectorString'],
    };
}
exports.NVDDetectionMetricsCvssMetricV31CvssDataFromJSONTyped = NVDDetectionMetricsCvssMetricV31CvssDataFromJSONTyped;
function NVDDetectionMetricsCvssMetricV31CvssDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attackVector': value.attackVector,
        'attackComplexity': value.attackComplexity,
        'privilegesRequired': value.privilegesRequired,
        'userInteraction': value.userInteraction,
        'scope': value.scope,
        'confidentialityImpact': value.confidentialityImpact,
        'integrityImpact': value.integrityImpact,
        'availabilityImpact': value.availabilityImpact,
        'baseScore': value.baseScore,
        'baseSeverity': value.baseSeverity,
        'exploitCodeMaturity': value.exploitCodeMaturity,
        'remediationLevel': value.remediationLevel,
        'reportConfidence': value.reportConfidence,
        'temporalScore': value.temporalScore,
        'temporalSeverity': value.temporalSeverity,
        'confidentialityRequirement': value.confidentialityRequirement,
        'integrityRequirement': value.integrityRequirement,
        'availabilityRequirement': value.availabilityRequirement,
        'modifiedAttackVector': value.modifiedAttackVector,
        'modifiedAttackComplexity': value.modifiedAttackComplexity,
        'modifiedPrivilegesRequired': value.modifiedPrivilegesRequired,
        'modifiedUserInteraction': value.modifiedUserInteraction,
        'modifiedScope': value.modifiedScope,
        'modifiedConfidentialityImpact': value.modifiedConfidentialityImpact,
        'modifiedIntegrityImpact': value.modifiedIntegrityImpact,
        'modifiedAvailabilityImpact': value.modifiedAvailabilityImpact,
        'environmentalScore': value.environmentalScore,
        'environmentalSeverity': value.environmentalSeverity,
        'version': value.version,
        'vectorString': value.vectorString,
    };
}
exports.NVDDetectionMetricsCvssMetricV31CvssDataToJSON = NVDDetectionMetricsCvssMetricV31CvssDataToJSON;
